const requiredIndexMessage = 'A primary index must be selected';

export const createPenCardFormValidation = {
  index: {
    required: requiredIndexMessage,
  },
};
